import { render, staticRenderFns } from "./BlockType116.vue?vue&type=template&id=eadc4ca0&scoped=true"
import script from "./BlockType116.vue?vue&type=script&lang=ts"
export * from "./BlockType116.vue?vue&type=script&lang=ts"
import style0 from "./BlockType116.vue?vue&type=style&index=0&id=eadc4ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadc4ca0",
  null
  
)

export default component.exports